import React from 'react';
import styled from 'styled-components';
import { Icon } from '../common';

const Wrapper = styled.div`
    position: relative;
    width: 24px;
    height: 24px;
`

const Badge = styled.div`
    background: ${props => props.theme.colors.error}
    border-radius: 50%;
    color: white;
    position: absolute;
    top: -5px;
    right: -5px;
    font-size: 10px;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
`


export const NotificationButton = ({number}) => (
    <Wrapper>
        <Icon name="notification" width={"24px"} height={"24px"} />
        {number > 0 && (
            <Badge>
                {number}
            </Badge>
        )}
    </Wrapper>
)